(function(angular) {
    //http://stackoverflow.com/questions/14703517/angular-js-set-element-height-on-page-load
    //<div ng-app="miniapp" ng-controller="AppController" ng-style="style()" resize>
    //    window.height: {{windowHeight}} <br />
    //    window.width: {{windowWidth}} <br />
    //</div>
    'use strict';

    var resize = function($window:any) {
        return function(scope:any) {
            var w = angular.element($window);
            scope.$watch(function() {
                return { 'h': w.height(), 'w': w.width() };
            }, function(newValue:any) {
                scope.windowHeight = newValue.h;
                scope.windowWidth = newValue.w;

                scope.style = function(widthOffset:any, heightOffset:any, maxHeight:any) {
                    var widthValue = angular.isString(widthOffset) && (widthOffset === 'auto' || widthOffset.indexOf('%') > 0) ? widthOffset : undefined;
                    var heightValue = angular.isString(heightOffset) && (heightOffset === 'auto' || heightOffset.indexOf('%') > 0) ? heightOffset : undefined;

                    if (angular.isUndefined(widthValue)) {
                        widthValue = (newValue.w - widthOffset) + 'px';
                    }

                    if (angular.isUndefined(heightValue)) {
                        heightValue = (newValue.h - heightOffset) + 'px';
                    }

                    return {
                        'width': widthValue,
                        'height': heightValue,
                        'max-height': maxHeight
                    };
                };

            }, true);

            w.bind('resize', function() {
                scope.$apply();
            });
        };
    };

    resize.$inject = ['$window'];
    angular.module('onvio.documents').directive('resize', resize);
})((window as any).angular);
